import React, {PropTypes, Component} from 'react';
import classnames from 'classnames';

import {
    BrowserRouter as Router,
    Route,
    Link
} from 'react-router-dom'

import './App.css';

export default class Home extends Component {
  // static propTypes = {}
  // static defaultProps = {}
  // state = {}

    render() {
        const {className, ...props} = this.props;
        return (
            <div className={classnames('Home', className)} {...props}>
                <div style={styles.flexContainer}>
                    <div style={styles.topDiv}>
                        <Link to="/deletephotosexceptfavorites">Delete Photos Except Favorites</Link>
                    </div>
                    <div>
                        <Link to="/about">About</Link>
                    </div>
                </div>
            </div>
        );
    }
}

const styles = {
    flexContainer: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    topDiv: {
        marginTop: 20,
    },
};


// WEBPACK FOOTER //
// ./src/Home.js